/* eslint-disable react/prefer-stateless-function */

// Controls for fine position adjustment of main video. Controls for zooming timeline.

import { observer } from 'mobx-react'

import { AdjustCurrentTimeButtons, ZoomInTimelineButton, ZoomOutTimelineButton } from '../utils/Buttons'

import { Passage } from '../../models3/Passage'
import { PassageVideo } from '../../models3/PassageVideo'

import { RefRange } from '../../scrRefs/RefRange'

const SECONDS_PER_HOUR = 3600

interface VideoPositionBarControlsProps {
    videoPositionControls: VideoPositionControls
    zoomIn: () => void
    zoomOut: () => void
    zoomInEnabled: boolean
    zoomOutEnabled: boolean
    adjustTimeEnabled: boolean
}

interface VideoPositionControls {
    currentTime: number
    duration: number
    adjustCurrentTime: (delta: number) => void
    setTimelineZoom: (zoom: number) => void
    useMobileLayout: boolean
    passage: Passage | null
    passageVideo: PassageVideo | null
    dbsRefs: RefRange[]
    displayableReferences: (refs: RefRange[]) => string
}

export const VideoPositionBarControls = observer(
    ({
        zoomIn,
        zoomOut,
        videoPositionControls,
        zoomInEnabled,
        zoomOutEnabled,
        adjustTimeEnabled
    }: VideoPositionBarControlsProps) => {
        const {
            currentTime,
            useMobileLayout,
            adjustCurrentTime,
            passage,
            passageVideo,
            dbsRefs,
            displayableReferences
        } = videoPositionControls

        // eslint-disable-next-line
        passageVideo && passageVideo._rev // for render on any passage video changes
        // eslint-disable-next-line
        passage && passage._rev // for render on any passage changes

        // Check to see if segment time have changed and if so reset them
        if (passage && passageVideo) {
            passageVideo.setSegmentTimes(passage)
        }

        const refs = displayableReferences(dbsRefs)
        const displayedRefs = refs.trim() ? `(${refs})` : ''
        return (
            <div data-id="video-positionbar-controls">
                <div className="sl-adjust-current-time">
                    <div className="video-timecode">
                        {new Date(Math.max(currentTime * 1000, 0))
                            .toISOString()
                            .substring(currentTime < SECONDS_PER_HOUR ? 14 : 11, 22)}{' '}
                        {displayedRefs}
                    </div>
                    {!useMobileLayout && (
                        <AdjustCurrentTimeButtons
                            enabled={adjustTimeEnabled}
                            adjustCurrentTime={adjustCurrentTime}
                            includeSeconds
                        />
                    )}
                    <div className="placeholder">
                        <ZoomInTimelineButton enabled={zoomInEnabled} onClick={zoomIn} />
                        <ZoomOutTimelineButton enabled={zoomOutEnabled} onClick={zoomOut} />
                    </div>
                </div>
            </div>
        )
    }
)
